// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SortFaculty_sort-faculty__MOwDj {
  text-transform: initial !important;
  color: var(--text-1) !important;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 24px !important; /* 150% */
  letter-spacing: 0.4px !important;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/SortEntity/SortFaculty.module.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,+BAAA;EACA,0EAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA,EAAA,SAAA;EACA,gCAAA;AACF","sourcesContent":[".sort-faculty {\n  text-transform: initial !important;\n  color: var(--text-1) !important;\n  font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif !important;\n  font-size: 16px !important;\n  font-style: normal !important;\n  font-weight: 600 !important;\n  line-height: 24px !important; /* 150% */\n  letter-spacing: 0.4px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sort-faculty": `SortFaculty_sort-faculty__MOwDj`
};
export default ___CSS_LOADER_EXPORT___;
